import {put,takeLatest,call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    GET_VENUES_STATUSES,
    GET_VENUES_STATUSES_SUCCESS,
    GET_VENUES_STATUSES_ERROR
}
    from "../../actions/venue";

function* getVenuesStatusesSaga(action) {
    try {
        const data=yield call(venueService.GetVenuesStatuses,action.payload)
        yield put({
            type: GET_VENUES_STATUSES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_VENUES_STATUSES_ERROR,error: error.data
        });
    }
}


export function* getVenuesStatusesSagaWatcher() {
    yield takeLatest(GET_VENUES_STATUSES,getVenuesStatusesSaga);
}